import { MdQuestionMark } from "react-icons/md";
import { formatDate } from "../../../../utils";
import { useLocation } from "react-router-dom";
import iconEvent from "../../../../assets/icon_event.svg";

const Detail = ({ productDetail, openModal }) => {
  const location = useLocation();
  const { sku_nm } = location.state || {};

  if (!productDetail) {
    return (
      <div className="flex flex-col gap-2.5 pt-14">
        <p className="text-3xl font-medium leading-10">{sku_nm}</p>
        <p className="mb-1 text-lg font-semibold text-neutral-500">
          해당 상품은 미입점 상품입니다. 양해 부탁드립니다.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2.5 pt-14">
      {productDetail?.imgUrl && (
        <div className="relative mb-6" style={{ paddingTop: "100%" }}>
          <img
            src={productDetail?.imgUrl}
            alt={productDetail?.sku_nm}
            className="absolute top-0 left-0 w-full h-full rounded-lg"
          />
        </div>
      )}
      {productDetail?.event !== null && productDetail?.event.event_desc && (
        <p className="text-sm font-semibold text-purple-500">
          {productDetail?.event[0].event_desc}
        </p>
      )}
      <p className="text-3xl font-medium leading-10">{productDetail?.sku_nm}</p>

      {productDetail?.stock_status === "UNDISCLOSED" ? (
        <p className="mb-1 text-lg font-semibold text-neutral-500">
          가격 안내가 어려운 상품입니다.
        </p>
      ) : (
        <>
          {productDetail?.discounted_rate ? (
            <div className="flex items-center gap-2">
              <p className="text-lg font-bold text-neutral-950">
                {productDetail?.discounted_rate}%
              </p>
              <p className="text-lg font-semibold line-through text-neutral-400">
                {productDetail?.sell_price.toLocaleString()}원
              </p>
            </div>
          ) : (
            <p className="mb-1 text-lg font-bold text-neutral-950">
              {productDetail?.sell_price.toLocaleString()}원
            </p>
          )}

          {productDetail?.discounted_rate && productDetail?.discounted_price ? (
            <div>
              <p className="font-semibold text-neutral-500">최대할인가</p>
              <div className="flex items-center gap-2.5 mb-2">
                <p className="flex items-center text-xl text-pink-600">
                  <b className="text-4xl font-bold ">
                    {productDetail?.discounted_price.toLocaleString()}
                  </b>
                  원
                </p>
                <button
                  className="flex items-center justify-center w-8 h-8 rounded-full bg-neutral-100"
                  onClick={() => openModal()}
                >
                  <MdQuestionMark
                    className="text-xl"
                    style={{ color: "#737373" }}
                  />
                </button>
              </div>
            </div>
          ) : null}
        </>
      )}
      {productDetail?.stock_status === "UNDISCLOSED" ? (
        ""
      ) : (
        <div className="flex justify-end mb-2.5">
          <p className="flex justify-center items-center px-4 text-center  h-9 rounded-[20px] border border-neutral-300 text-neutral-500 text-sm font-medium">
            재고수량 : {productDetail?.stock_qty.toLocaleString()}개
          </p>
        </div>
      )}
    </div>
  );
};

const EventInfo = ({ productDetail }) => {
  const { event_start_date, event_end_date } =
    Array.isArray(productDetail?.event) && productDetail?.event.length > 0
      ? productDetail?.event[0]
      : { event_start_date: null, event_end_date: null };

  const startDateFormatted = event_start_date
    ? formatDate(event_start_date)
    : null;
  const endDateFormatted = event_start_date ? formatDate(event_end_date) : null;

  return (
    <>
      {productDetail?.event && (
        <div className="bg-slate-50 rounded-[20px] p-5">
          <h3 className="flex items-center gap-1.5 text-lg font-semibold">
            <span>
              <img src={iconEvent} alt="" />
            </span>
            구매혜택
          </h3>
          <div className="p-1.5">
            {event_start_date && event_end_date && (
              <div>
                <p className="pb-3 text-sm font-medium border-b text-neutral-500 border-neutral-200">
                  행사기간 : {`${startDateFormatted} ~ ${endDateFormatted}`}
                </p>
              </div>
            )}
            <ul className="flex flex-col gap-3.5">
              {productDetail.event.map((event, index) => {
                const { event_title, event_desc } = event;
                return (
                  <li key={index} className="pt-3 text-sm">
                    <p className="mb-0.5 font-semibold border-r border-zinc-100">
                      {event_title}
                    </p>
                    <div className="flex items-end gap-4">
                      <p
                        className="flex-1 font-medium text-neutral-600 break-keep"
                        dangerouslySetInnerHTML={{ __html: event_desc }}
                      />
                      <p className="text-base font-bold shrink-0 text-neutral-900">
                        {
                          productDetail.discounted_amount > 0 && `-${productDetail.discounted_amount.toLocaleString()}원`
                        }
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

const ProductView = ({ productDetail, openModal }) => {
  return (
    <>
      <Detail productDetail={productDetail} openModal={openModal} />
      <EventInfo productDetail={productDetail} />
      {/* <Event productDetail={productDetail} /> */}
    </>
  );
};

export default ProductView;
